/** @format */

import React, { Component } from "react";
import * as qs from "query-string";
import { toast } from "react-toastify";
import { Dropdown } from "react-bootstrap";
import debounce from "lodash.debounce";
import { ApiRoutes, AppRoutes, SocketEvents } from "../../../config";
import { ApiHelper } from "../../../helpers";
import Pagination from "../../components/pagination";
import { ListComponent } from "../../components/scans";
import { FilterComponent } from "../../components/filters/filterComponent";
import PHLContext from "../../../PHLContext";
import SearchFilter from "../../components/filters/SearchFilter";
import { Breadcrumbs } from "../../components/partial/Breadcrumbs";
import filterarrowIcon from "../../../assets/img/filter-arrow.svg";
import pageDropdownIcon from "../../../assets/img/home_icon.svg";
import mobSearchIcon from "../../../assets/img/home_icon.svg";
import rightPageArrow from "../../../assets/img/rightPageArrow.svg";
import leftPageArrow from "../../../assets/img/leftPageArrow.svg";
import FilterDropdown from "../../components/filters/FilterDropdown";
import "./scans.css";

let lat, long;

class Scans extends Component {
  static contextType = PHLContext;
  constructor(props) {
    super(props);
    this.state = {
      scans: [],
      isLoading: false,
      totalRecords: 0,
      currentPage: 1,
      limit: 10,
      activeId: "",
      sortBy: "created_at",
      order: "desc",
      search: "",
      newRecord: false,
      isFilterApplied: false,
    };
    this.emitSearch = debounce(this.onSearch, 200);
  }
  componentDidMount = () => {
    let { socket } = this.context;
    if (socket) {
      socket.on(SocketEvents.NEW_SCAN_ADDED, (data) => {
        console.log("event emitted", data);
        // this.props.history.push(AppRoutes.SCANS_LIST);
        let newData = [...this.state.scans];
        const alreadyExistIndex = newData.findIndex(
          (item) => item.scanId === data[0].scanId
        );
        if (alreadyExistIndex > -1) {
          newData.splice(alreadyExistIndex, 1);
          newData.unshift(...data);
        } else {
          newData.splice(-1, 1);
          newData.unshift(...data);
        }
        this.setState({ scans: newData });
      });
    }
    this.handleQueryParams();
  };
  handleQueryParams = async () => {
    const {
      location: { search },
    } = this.props;
    const query = qs.parse(search);
    if (query && query.sort === "location") {
      const position = await new Promise((resolve, reject) => {
        navigator.geolocation.getCurrentPosition(resolve, reject);
      });
      lat = position.coords.latitude;
      long = position.coords.longitude;
    }
    this.setState(
      {
        currentPage: query.page ? parseInt(query.page) : 1,
        limit: query.limit ? parseInt(query.limit) : 10,
        sortBy: query.sort || "created_at",
        order: query.order
          ? query.order
          : // : query.sort === 'scan_id' || query.sort === 'created_at'
            // ? 'desc'
            "desc",
        search: query.search || "",
        isFilterApplied: query.sort || query.search ? true : false,
      },
      () => this.fetchScanRecords()
    );
  };

  componentDidUpdate = ({ location: { search: prevSearch } }) => {
    const {
      location: { search },
    } = this.props;
    if (prevSearch !== search) {
      this.handleQueryParams();
    }
  };

  fetchScanRecords = async () => {
    const { currentPage, sortBy, search, limit, newRecord, order } = this.state;
    let skip = limit * (currentPage - 1);
    let data = {
      skip,
      limit,
      sortBy,
      search,
      order,
      lat,
      long,
    };
    this.setState({
      isLoading: newRecord ? false : true,
    });
    if (search && this.state.isLoading) {
      new ApiHelper().cancelRequest("cancel");
    }
    const response = await new ApiHelper().FetchFromServer(
      ApiRoutes.SCANS_LIST.service,
      ApiRoutes.SCANS_LIST.url,
      ApiRoutes.SCANS_LIST.method,
      ApiRoutes.SCANS_LIST.authenticate,
      data,
      undefined
    );
    this.setState({
      isLoading: false,
    });
    if (response && response.isError) {
      toast.error(response.messages[0]);
    } else {
      const {
        data: { scans, totalRecords },
      } = response.data;
      this.setState({ scans, totalRecords, newRecord: false });
    }
  };

  onLimitChange = (limit) => {
    const {
      location: { search, pathname },
    } = this.props;
    const query = qs.parse(search);
    this.props.history.push(
      [pathname, qs.stringify({ ...query, page: 1, limit })].join("?")
    );
  };
  onPageChanged = (page) => {
    const { currentPage } = this.state;
    if (page !== currentPage) {
      const {
        location: { search, pathname },
      } = this.props;
      const query = qs.parse(search);
      this.props.history.push(
        [pathname, qs.stringify({ ...query, page })].join("?")
      );
    }
  };

  setFilter = (sortBy, order) => {
    const {
      props: {
        location: { search: searchParam, pathname },
      },
    } = this;
    const query = qs.parse(searchParam);
    let params = {};
    params.page = 1;
    if (sortBy) {
      params.sort = sortBy;
    }
    if (order) {
      params.order = order;
    }
    this.props.history.push(
      [pathname, qs.stringify({ ...query, ...params })].join("?")
    );
  };

  handleChange = (event) => {
    const {
      target: { name, value },
    } = event;
    // console.log("here is search change", event.target.value);

    this.setState({ [name]: value });
    event.persist();
    this.emitSearch();
  };

  onSearch = () => {
    const { search } = this.state;
    console.log("here is onSearch", search);
    const {
      props: {
        location: { search: searchParam, pathname },
      },
    } = this;
    const query = qs.parse(searchParam);
    console.log("here is query", query);
    let params = {};
    params.page = 1;
    params.search = search;
    this.props.history.push(
      [pathname, qs.stringify({ ...query, ...params })].join("?")
    );
  };

  componentWillUnmount = () => {
    this.emitSearch.cancel();
  };

  batchViewHandler = (id) => {
    this.props.history.push(AppRoutes.VIEW_BATCH.replace(":id", id));
  };
  userViewHandler = (id) => {
    this.props.history.push(AppRoutes.VIEW_USER.replace(":id", id));
  };

  render() {
    const {
      scans,
      isFilterApplied,
      isLoading,
      totalRecords,
      currentPage,
      limit,
      sortBy,
      order,
      search,
    } = this.state;
    const {
      props: {
        location: { pathname },
      },
    } = this;
    const filtersOption = [
      {
        label: "Scan ID",
        value: "scan_id",
      },
      {
        label: "Batch Number",
        value: "batch_number",
      },
      {
        label: "Product Name",
        value: "product_name",
      },
      {
        label: "User Name",
        value: "user_name",
      },
      {
        label: "Location",
        value: "location",
      },
      {
        label: "Scan Time",
        value: "created_at",
      },
    ];

    const pagesOption = [
      {
        label: "10 Per page",
        value: 10,
      },
      {
        label: "20 Per page",
        value: 20,
      },
      {
        label: "50 Per page",
        value: 50,
      },
    ];
    return (
      <div className="container-fluid fluid-pd-2">
        {/* <h1 className="h3-head-mob d-md-none">Scans</h1> */}
        <div className="tableFilter overflow-hidden btachMain add_batch d-flex justify-content-between pl-0 mb-0 mt-0">
          <h3 className="mt-0 breadcrumbDark mb-0 custombreadcrumbMargin">
            <Breadcrumbs
              pathname={pathname}
              customBreadCrumb={this.customBreadCrumb}
            />
          </h3>
        </div>
        <div className="tableFilter d-flex justify-content-between mb-0 mb-lg-4">
          {/* <h3>
            <Breadcrumbs pathname={pathname} />
          </h3> */}
          <SearchFilter
            placeholder={"Search by Scan/Report ID, Batch Number..."}
            search={search}
            onChange={this.handleChange}
            onSearch={this.onSearch}
          />
          <div className="d-flex filter_holder">
            <FilterComponent
              // filtersOption={filtersOption}
              // pagesOption={pagesOption}
              // sortBy={sortBy}
              // setFilter={this.setFilter}
              label={"Sort By"}
              options={filtersOption}
              selectedFilter={sortBy}
              onFilterChange={(selectedValue) =>
                this.setFilter(selectedValue, "status")
              }
            />
          </div>
          {/* <div className='d-flex'>
                <Dropdown className='no-arrow dp-right'>
                  <Dropdown.Toggle
                    variant='secondary'
                    id='dropdown-basic'
                    className={'filter-btn-mob'}
                  >
                    <img src={pageDropdownIcon} alt='' />
                  </Dropdown.Toggle>

                  <Dropdown.Menu className='shadow dropdown-menu-right dropdown-opt-mob mob-drp'>
                    {filtersOption.map(({ label, value }, index) => (
                      <Dropdown.Item
                        as='div'
                        key={index}
                        onClick={() => this.setFilter(value)}
                      >
                        {label}
                      </Dropdown.Item>
                    ))}
                  </Dropdown.Menu>
                </Dropdown>

                <div className='dropdown no-arrow dp-right'>
                  <button
                    type='button'
                    className='btn btn-secondary filter-btn-mob'
                    id='statusMenuLink-mob'
                    data-toggle='dropdown'
                    aria-haspopup='true'
                    aria-expanded='false'
                  >
                    <img src={mobSearchIcon} alt='' />
                  </button>
                </div>
              </div> */}
        </div>

        <div className="tableCard card">
          <ListComponent
            scans={scans}
            isFilterApplied={isFilterApplied}
            isLoading={isLoading}
            totalRecords={totalRecords}
            limit={limit}
            currentPage={currentPage}
            onPageChanged={this.onPageChanged}
            batchViewHandler={this.batchViewHandler}
            userViewHandler={this.userViewHandler}
            setFilter={this.setFilter}
            order={order}
            sortBy={sortBy}
          />
        </div>
        <div className="footer-pg px-3">
          {!isLoading ? (
            <>
              {/* <div className="float-left mt-2">
                <p className="page-desc-left">
                  Total: <span className="bold-black">{totalRecords}</span>
                </p>
              </div> */}
              <div className="float-left mt-2">
                <div>
                  <p className="totalRecords">
                    Page {totalRecords > 0 ? currentPage : 0} of{" "}
                    {totalRecords % limit > 0
                      ? parseInt(totalRecords / limit) + 1
                      : parseInt(totalRecords / limit)}{" "}
                  </p>
                </div>
              </div>
              <div className="float-right mt-0">
                {/* <p className="page-desc ml-2 float-right">Table View</p> */}

                {/* <Dropdown className="no-arrow dp-right ml-2">
                  <Dropdown.Toggle
                    variant="secondary"
                    id="dropdown-basic"
                    className={'filter-btn'}
                  >
                    {' '}
                    <span className="staff-value">
                      {
                        (
                          pagesOption.filter(
                            (filter) => filter.value === limit
                          )[0] || {}
                        ).label
                      }
                    </span>{' '}
                    <img src={filterarrowIcon} alt="" />
                  </Dropdown.Toggle>
                  <Dropdown.Menu className="shadow top-open dropdown-menu-right dropdown-staff">
                    {pagesOption.map(({ label, value }, index) => (
                      <Dropdown.Item
                        as="div"
                        key={index}
                        onClick={() => this.onLimitChange(value)}
                      >
                        {label}
                      </Dropdown.Item>
                    ))}
                  </Dropdown.Menu>
                </Dropdown> */}
                <div className="d-flex align-items-center tableFooter">
                  {totalRecords > limit ? (
                    <div className="float-right d-flex align-items-center">
                      {/* <button className="paginationArrows">
                        <img src={leftPageArrow} />
                      </button> */}
                      <Pagination
                        totalRecords={totalRecords}
                        currentPage={currentPage}
                        pageLimit={limit}
                        onPageChanged={this.onPageChanged}
                      />
                      {/* <button className="paginationArrows">
                        <img src={rightPageArrow} />
                      </button> */}
                    </div>
                  ) : null}
                </div>
              </div>
            </>
          ) : null}
        </div>
      </div>
    );
  }
}

export default Scans;
